import React, {
  useState,
  cloneElement,
  CSSProperties,
  ReactElement,
} from "react";
import { Button, CircularProgress } from "@mui/material";
import { authenticateUserGoogle } from "../cognito/kahunUserAuth";
import { ReactComponent as GoogleLogo } from "./assets/googleLogo.svg";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface GoogleButtonProps {
  redirectTo: string;
  onClick?: () => void;
  onError?: (error: string) => void;
  style?: CSSProperties;
  className?: string;
  customButton?: ReactElement;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const GoogleButton = ({ ...props }: GoogleButtonProps) => {
  const [googleLogging, setGoogleLogging] = useState(false);

  const startIconRender = () => {
    if (googleLogging) {
      return <CircularProgress size={20} />;
    }
    return <GoogleLogo />;
  };
  const handleGoogleLogin = async () => {
    setGoogleLogging(true);
    setTimeout(() => {
      authenticateUserGoogle(props.redirectTo || "/")
        .then(() => {
          if (props.onClick) {
            props.onClick();
          }
        })
        .catch((err) => {
          props.onError(err.message);
          setGoogleLogging(false);
        });
    }, 300);
  };

  return props.customButton ? (
    cloneElement(props.customButton, {
      onClick: handleGoogleLogin,
      disabled: googleLogging,
      startIcon: startIconRender(),
    })
  ) : (
    <Button
      className={"google-login" + props.className ? " " + props.className : ""}
      startIcon={startIconRender()}
      variant={"outlined"}
      onClick={handleGoogleLogin}
      disabled={googleLogging}
      fullWidth
      style={props.style}
    >
      Sign in with Google
    </Button>
  );
};
